import { Card, Flex, Icon, Image, Text, VStack } from '@chakra-ui/react';
import isNil from 'lodash/isNil';
import { BathIcon, BedSingleIcon, CalendarIcon, RulerIcon } from 'lucide-react';
import {
  DEFAULT_PROPERTY_IMAGE_URL,
  getPropertySource,
} from '~/apps/consumer/utils/listing.utils';
import { numberFormatter } from '~/common/utils/formatter';
import { useListingPageContext } from '../../ListingPageContext';
import { getPropertyDetails } from '../../utils';

export const ListingPageMobileHeader = () => {
  const { listing, propertyDetails } = useListingPageContext();
  const {
    photos,
    streetAddress,
    secondAddressLine,
    bedrooms,
    bathrooms,
    area,
    daysOnMarket,
  } = getPropertyDetails(listing, propertyDetails);

  return (
    <Flex direction="column" gap={2}>
      <Card mt={2} p={2} width="100%">
        <Flex alignItems="center">
          <Image
            borderRadius="4px"
            fallbackSrc={DEFAULT_PROPERTY_IMAGE_URL}
            height="60px"
            src={getPropertySource(photos?.[0])}
            width="80px"
          />
          <VStack alignItems="flex-start" minWidth="0" px={2}>
            <Text
              overflow="hidden"
              p={0}
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              width="100%"
            >
              {streetAddress ?? ''}
              {secondAddressLine ?? ''}
            </Text>
            <Flex
              gap={1}
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {!isNil(bedrooms) && (
                <Flex alignItems="center" gap={0.5}>
                  <Icon as={BedSingleIcon} color="whiteAlpha.700" />
                  <Text color="whiteAlpha.700" fontSize="sm">
                    {bedrooms} beds
                  </Text>
                </Flex>
              )}
              {!isNil(bathrooms) && (
                <Flex alignItems="center" gap={0.5}>
                  <Icon as={BathIcon} color="whiteAlpha.700" />
                  <Text color="whiteAlpha.700" fontSize="sm">
                    {bathrooms} baths
                  </Text>
                </Flex>
              )}
              {!isNil(area) && (
                <Flex alignItems="center" gap={0.5}>
                  <Icon as={RulerIcon} color="whiteAlpha.700" />
                  <Text color="whiteAlpha.700" fontSize="sm">
                    {numberFormatter(area, { maxPrecision: 0 })} sqft
                  </Text>
                </Flex>
              )}
              {!isNil(daysOnMarket) && (
                <Flex alignItems="center" gap={0.5}>
                  <Icon as={CalendarIcon} color="whiteAlpha.700" />
                  <Text color="whiteAlpha.700" fontSize="sm">
                    {daysOnMarket}
                    {' d'}
                  </Text>
                </Flex>
              )}
            </Flex>
          </VStack>
        </Flex>
      </Card>
    </Flex>
  );
};
